// HELPERS
import tableFilter from '../../../../helpers/tableFilter';

// UTILS
import naUTL from '../../../../../../utils/naUTL';

const jsonTableRow = (dataSources) => {
  const { nationalIDNumber, watchlistAML, residential } = dataSources;

  const table = [
    {
      col1: 'Status',
      col2: naUTL(nationalIDNumber.status),
      col3: naUTL(watchlistAML.status),
      col4: naUTL(residential.status)
    },
    {
      col1: 'Safe Harbour Score',
      col2: naUTL(nationalIDNumber.safeHarbourScore),
      col3: naUTL(watchlistAML.safeHarbourScore),
      col4: naUTL(residential.safeHarbourScore)
    },
    {
      col1: 'Identity Verified',
      col2: naUTL(nationalIDNumber.identityVerified),
      col3: naUTL(watchlistAML.identityVerified),
      col4: naUTL(residential.identityVerified)
    },
    {
      col1: 'First Name Verified',
      col2: naUTL(nationalIDNumber.verifications.firstName),
      col3: naUTL(watchlistAML.verifications.firstName),
      col4: naUTL(residential.verifications.firstNam)
    },
    {
      col1: 'Middle Name Verified',
      col2: naUTL(nationalIDNumber.verifications.lastName),
      col3: naUTL(watchlistAML.verifications.lastName),
      col4: naUTL(residential.verifications.lastName)
    },
    {
      col1: 'Last Name Verified',
      col2: naUTL(nationalIDNumber.verifications.lastName),
      col3: naUTL(watchlistAML.verifications.lastName),
      col4: naUTL(residential.verifications.lastName)
    },
    {
      col1: 'Date of Birth Verified',
      col2: naUTL(nationalIDNumber.verifications.dateOfBirth),
      col3: naUTL(watchlistAML.verifications.dateOfBirth),
      col4: naUTL(residential.verifications.dateOfBirth)
    },
    {
      col1: 'Street No Verified',
      col2: naUTL(nationalIDNumber.verifications.addressElement1),
      col3: naUTL(watchlistAML.verifications.addressElement1),
      col4: naUTL(residential.verifications.addressElement1)
    },
    {
      col1: 'Street Name Verified',
      col2: naUTL(nationalIDNumber.verifications.addressElement1),
      col3: naUTL(watchlistAML.verifications.addressElement1),
      col4: naUTL(residential.verifications.addressElement1)
    },
    {
      col1: 'City Verified',
      col2: naUTL(nationalIDNumber.verifications.addressElement3),
      col3: naUTL(watchlistAML.verifications.addressElement3),
      col4: naUTL(residential.verifications.addressElement3)
    },
  ];

  return tableFilter(table);
};

export default jsonTableRow;

